import React from 'react';

function NSResize({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M9.99876 12.6667L7.99999 14.6655L6.00124 12.6667" />
      <path d="M8 1.33398L8 14.6653" />
      <path d="M9.99876 3.33274L8 1.33398L6.00124 3.33275" />
    </svg>
  );
}

export default NSResize;
